export function getLocationAcidAddress(l) {
    var _a;
    var country;
    var customerCountry = l.customer_country || '';
    switch (customerCountry.toLocaleUpperCase().substring(0, 2)) {
        case 'US':
            country = 'USA';
            break;
        case 'CA':
            country = 'CAN';
            break;
        default:
            country = undefined;
            break;
    }
    return {
        address1: l.customer_addr1,
        address2: (_a = l.customer_addr2) !== null && _a !== void 0 ? _a : undefined,
        city: l.customer_city,
        state: l.customer_state,
        zip: l.customer_zip,
        country: country,
    };
}
export function getLocationAcidAccountNumbers(l, useMdmId) {
    var _a;
    var ct = (l.customer_type || '').toLocaleUpperCase();
    return {
        parentCompany: ct === 'PC' ? l.customer_number : undefined,
        homeOffice: ct === 'HO' ? l.customer_number : undefined,
        billTo: ct === 'BT' ? l.customer_number : undefined,
        shipTo: ct === 'ST' ? l.customer_number : undefined,
        mdm: useMdmId ? (_a = l.mdm) === null || _a === void 0 ? void 0 : _a.site_id : undefined,
    };
}
//# sourceMappingURL=utils.js.map